import { isEmpty } from 'lodash';
import { type UnsavedChangesPayload } from '@editor2/types/unsavedChangesPayload';

const isValidElements = (elements) => {
	for (const element of elements) {
		if (isEmpty(element)) return false;

		// choices from MCQ or Poll element
		if (element.choices && element.choices.some((choice) => isEmpty(choice))) return false;
	}

	return true;
};

const isValidPages = (pages) => {
	for (const page of pages) {
		if (isEmpty(page)) return false;
		if (page.elements && !isValidElements(page.elements)) return false;
	}

	return true;
};

const isValidPageGroups = (pageGroups) => {
	for (const pageGroup of pageGroups) {
		if (isEmpty(pageGroup)) return false;
		if (pageGroup.pages && !isValidPages(pageGroup.pages)) return false;
	}

	return true;
};

/**
 * Check whether chapter/page_group/page/element
 * (including choices in MCQ and Poll) aren't empty objects.
 *
 * If an element is passed as an empty object - {}, it'll be saved as NG::Soomo::Asset.
 * We add this check to prevent saving empty elements until we can find the reason why that happened before.
 */
export const isValidChangesPayload = (payload: UnsavedChangesPayload) => {
	if (!payload.book.chapters) return true;

	for (const chapter of payload.book.chapters) {
		if (isEmpty(chapter)) return false;

		if (chapter.page_groups && !isValidPageGroups(chapter.page_groups)) return false;
		if (chapter.pages && !isValidPages(chapter.pages)) return false;
	}

	return true;
};

export const validateChangesPayload = (payload: UnsavedChangesPayload) => {
	if (!isValidChangesPayload(payload)) {
		console.error(`Invalid changes payload: ${JSON.stringify(payload)}`);
		throw new Error(`Invalid changes payload. Please, try again or contact the tech department.`);
	}
};
